<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-8">
        <Loader v-if="!outputReady" />
        <div v-if="outputReady">
          <div>
            <div class="header_icon_bar">
              <div><h4 style="margin-bottom:20px;margin-top:20px;">Fragen & Antworten</h4></div>
            </div>
          </div>
          <div class="faq-container">
            <div class="faq-category" v-for="(item, index) in questionsToCategories" :key="index + 'cat'">
              <div class="faq-head" v-if="item.length">
                <h5 style="margin-bottom:20px">{{ index.charAt(0).toUpperCase() + index.slice(1) }}</h5>
                <div class="create-icon">
                  <feather class="infra-blue pointer" v-if="isAdmin" @click="openModal('createTopicModal', index)" type="plus" size="30"></feather>
                </div>
              </div>
              <div class="faq-items default-according style-1 faq-accordion">
                <b-card no-body class="col-12" v-for="faq in item" :key="faq.id + 'faq'" role="tab">
                  <b-card-header header-tag="div" role="tab" class="accordion-header-with-icons">
                    <b-button v-b-toggle="'accordion-' + faq.id" variant="default">
                      <feather type="help-circle" size="20" class="infra-blue inline-block"></feather>
                      <h6 style="display:inline-block; margin-left:10px;vertical-align:top;">{{ faq.titel }}</h6></b-button
                    >
                  </b-card-header>
                  <b-collapse :id="'accordion-' + faq.id" accordion="faq_accordion" role="tabpanel">
                    <b-card-body>
                      <h5>{{ faq.frage }}</h5>
                      <b-card-text v-html="faq.antwort">
                        
                      </b-card-text>
                    </b-card-body>
                    <div class="icons-right">
                      <feather
                        type="edit-2"
                        :id="'tt_edit_acc' + faq.id"
                        class="pointer infra-blue"
                        v-if="isAdmin"
                        @click="openEditModal(faq)"
                      ></feather>
                      <b-tooltip :target="'tt_edit_acc' + faq.id" triggers="hover" placement="left">Thema bearbeiten</b-tooltip>
                      <feather
                        type="trash"
                        :id="'tt_delete_acc' + faq.id"
                        class="pointer infra-blue"
                        v-if="isAdmin"
                        @click="openDeleteModal(faq)"
                      ></feather>
                      <b-tooltip :target="'tt_delete_acc' + faq.id" triggers="hover" placement="left">Thema löschen</b-tooltip>
                    </div>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
          <b-modal
            id="deleteTopicModal"
            size="md"
            @ok="deleteTopic"
            @hide="resetModalState('deleteTopicModal')"
            @cancel="closeModal('deleteTopicModal')"
          >
            <div class="container-fluid">
              "{{ modal.delete.titel }}"<br />
              Möchten Sie dieses Thema wirklich löschen ?
            </div>
            <template slot="modal-header">
              <h4>Thema löschen ?</h4>
            </template>
            <template slot="modal-ok">
              Löschen
            </template>
            <template slot="modal-cancel">
              Abbrechen
            </template>
          </b-modal>
          <b-modal id="editTopicModal" size="lg" @ok="editTopic" @hide="resetModalState('editTopicModal')" @cancel="closeModal('editTopicModal')">
            <div class="container-fluid">
              <div class="form-container">
                <label>Titel</label>
                <b-input-group class="form-input-group" prepend="Abc">
                  <b-input v-model="modal.edit.titel"></b-input>
                </b-input-group>
                <label>Frage</label>
                <b-input-group style="margin-bottom:10px;">
                  <b-input rows="10" v-model="modal.edit.frage"></b-input>
                </b-input-group>
                <label>Antwort</label>
                <vue-editor v-model="modal.edit.antwort" :editorToolbar="editorOptions"></vue-editor>
              </div>
            </div>
            <template slot="modal-header">
              <h4>Thema editieren für Kategorie {{ getCatName(this.modal.edit.kategorie) }}</h4>
            </template>
            <template slot="modal-ok">
              Speichern
            </template>
            <template slot="modal-cancel">
              Abbrechen
            </template>
          </b-modal>
          <b-modal
            id="createTopicModal"
            size="lg"
            @ok="createNewTopic"
            @hide="resetModalState('createTopicModal')"
            @cancel="closeModal('createTopicModal')"
          >
            <div class="container-fluid">
              <div class="form-container">
                <label>Titel</label>
                <b-input-group class="form-input-group" prepend="Abc">
                  <b-input v-model="modal.create.titel"></b-input>
                </b-input-group>
                <label>Frage</label>
                <b-input-group style="margin-bottom:10px;">
                  <b-input rows="10" v-model="modal.create.frage"></b-input>
                </b-input-group>
                <label>Antwort</label>
                <vue-editor v-model="modal.create.antwort" :editorToolbar="editorOptions"></vue-editor>
              </div>
            </div>
            <template slot="modal-header">
              <h4>Neues Thema erstellen für Kategorie {{ getCatName(this.modal.create.kategorie) }}</h4>
            </template>
            <template slot="modal-ok">
              Erstellen
            </template>
            <template slot="modal-cancel">
              Abbrechen
            </template>
          </b-modal>
        </div>
      </div>
      <div class="col-4">
        <Ansprechpartner show_themen="Kommunikationstool" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader.vue";
import { VueEditor } from "vue2-editor";
import Ansprechpartner from "@/widget/Ansprechpartner.vue";

export default {
  name: "KundeHilfe",
  components: {
    Loader: Loader,
    VueEditor: VueEditor,
    Ansprechpartner,
  },
  data() {
    return {
      modal: {
        create: {},
        edit: {},
        delete: {},
      },
      questionsToCategories: {},
      outputReady: false,
      updating: {
        create: false,
        edit: false,
        delete: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      questions: "kb/all",
      categories: "kb/categories",
      isAdmin: "auth/isAdmin",
      ready: "kb/readyState",
      toasts: "app/toasts",
      questionsUpdating: "kb/updateState",
      animations: "app/animations",
      validation: "app/validation",
      editorOptions: "app/editorOptions",
    }),
  },
  async created() {
    if (!this.ready) {
      try {
        await this.$store.dispatch("kb/init");
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden der Daten.", this.toasts.failure);
      }
    }
    this.buildQuestionsToCategories();
  },
  methods: {
    openEditModal(topic) {
      this.modal.edit = topic;
      this.$bvModal.show("editTopicModal");
    },
    openDeleteModal(topic) {
      this.modal.delete = topic;
      this.$bvModal.show("deleteTopicModal");
    },
    openModal(modal, data = null) {
      this.modal.create.kategorie = this.categories.find((c) => c.name == this.ucFirst(data)).id;
      this.$bvModal.show(modal);
    },
    closeModal(modal) {
      this.$bvModal.hide(modal);
    },
    resetModalState(modal) {
      switch (modal) {
        case "createTopicModal":
          this.modal.create = {};
          break;
        case "editTopicModal":
          this.modal.edit = {};
          break;
        case "deleteTopicModal":
          this.modal.delete = {};
          break;
      }
    },
    async createNewTopic() {
      try {
        this.updating.create = true;
        await this.$store.dispatch("kb/createNewTopic", this.cloneNonReactive(this.modal.create));
        await this.$store.dispatch("kb/getQuestions");
        this.buildQuestionsToCategories();
        this.closeModal("createTopicModal");
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Erstellen der Frage.", this.toasts.failure);
      } finally {
        this.updating.create = false;
      }
    },
    async editTopic() {
      console.log(this.modal.edit);
      const payload = {
        collection: "kb",
        item: this.modal.edit.id,
        changes: {
          titel: this.modal.edit.titel,
          frage: this.modal.edit.frage,
          antwort: this.modal.edit.antwort,
        },
      };
      try {
        await this.$store.dispatch("app/mutate", payload);
        await this.$store.dispatch("kb/init");
        this.closeModal("editTopicModal");
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim aktualisieren der Daten.", this.toasts.failure);
      }
    },
    async deleteTopic() {
      console.log("deleting topic");
      const payload = {
        collection: "kb",
        items: [this.modal.delete.id],
      };
      try {
        await this.$store.dispatch("app/removeItems", payload);
        await this.$store.dispatch("kb/init");
        this.buildQuestionsToCategories();
        this.closeModal("deleteTopicModal");
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Löschen.", this.toasts.failure);
      }
    },
    async buildQuestionsToCategories() {
      this.outputReady = false;
      this.questionsToCategories = {};
      if (!this.questions.length || !this.categories.length) return;
      for (let idx = 0; idx < this.categories.length; idx++) {
        if (!this.questionsToCategories.hasOwnProperty(this.categories[idx].name.toLowerCase()))
          this.questionsToCategories[this.categories[idx].name.toLowerCase()] = [];
      }

      for (let idx = 0; idx < this.questions.length; idx++) {
        const category = this.categories.find((c) => c.id == this.questions[idx].kategorie);
        this.questionsToCategories[category.name.toLowerCase()].push(this.questions[idx]);
      }

      this.outputReady = true;
    },
    getCatName() {
      if (!this.modal.create.kategorie || !this.modal.edit.kategorie) return;

      return this.categories.find((c) => c.id == this.modal.create.kategorie).name;
    },
  },
};
</script>

<style scoped>
.faq-head {
  display: inline-flex;
  flex-flow: row;
}

.faq-head h5 {
  text-transform:capitalize;
}

.accordion-header-with-icons {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding: 20px !important;
  padding-left: 0px !important;
}

.faq-items {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  align-items: flex-start;
}

.faq-items .card {
  margin-right: 10px;
}

.icons-right {
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>

<style>
p.card-text ul {
  list-style-type: square !important;
}
</style>
